import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

import {RoutingService} from '../../../services/routing.service';

@Component({
  selector: 'terra-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoAccessComponent implements OnInit {
  errorMessage$ = new BehaviorSubject<string>('');

  constructor(private titleService: Title,
              private routingService: RoutingService,
              private router: Router) {
    this.titleService.setTitle('No Access');
    const message = this.router.getCurrentNavigation()?.extras?.state?.message;
    if (!!message) {
      this.errorMessage$.next(message);
    }
  }

  ngOnInit(): void {
  }

  get buttonUrl(): string {
    return this.routingService.defaultGpPage;
  }
}
